
function translateTerpeneType(type, isEnzyme = false) {
    if (type != "pt" && type != "sesq" && type != "sqs" && type != "psy" && type != "mero" && type != null)
    {
        if (isEnzyme){
            return type + "terpene synthase";
        }
        return type + "terpene";
    }
    else if (type == "pt"){
        if (isEnzyme){
            return "isoprenyl diphosphate synthase";
        }
        return "isoprenyl diphosphate"
    }
    else if (type == "sesq"){
        if (isEnzyme){
            return "sesquiterpene synthase";
        }
        return "sesquiterpene"
    }
    else if (type == "sqs"){
        if (isEnzyme){
            return "squalene synthase";
        }
        return "squalene"
    }
    else if (type == "psy"){
        if (isEnzyme){
            return "phytoene synthase";
        }
        return "phytoene"
    }
    else if (type == "mero"){
        if (isEnzyme){
            return "meroterpenoid synthase";
        }
        return "meroterpenoid"
    }
    else if (type == null){
        return "terpenoid"
    }
    else{
        return type;
    }
}

export default translateTerpeneType;